<template>
  <div class="image-preview" :class="{ 'image-preview-disabled': disableClick }">
    <label class="image-preview-label" :for="'file[' + index + ']'" @click="fileClick($event)">
      <input type="file" :id="'file[' + index + ']'" class="image-preview-input" accept="image/*" ref="file" @click="resetImageUpload()" @change="handleImageUpload()">
    </label>
    <transition name="image-fade">
      <img class="item-preview-image" :src="image" v-show="show">
    </transition>
    <i class="fas fa-camera"></i>
    <div class="item-preview-delete" v-show="show" @click="imageDelete()">
      <i class="fas fa-times"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImagePreview',
  props: ['index', 'disableClick', 'resetPreview'],
  data () {
    return {
      file: null,
      image: null,
      show: false
    }
  },
  methods: {
    fileClick (event) {
      if (this.disableClick) {
        event.preventDefault()
      }
    },
    imageDelete () {
      this.file = null
      this.show = false
      this.$emit('input', this.file)
    },
    resetImageUpload () {
      this.$refs.file.value = ''
    },
    handleImageUpload () {
      this.file = this.$refs.file.files[0]
      let reader = new FileReader()

      reader.addEventListener('load', function () {
        this.show = true
        this.image = reader.result
      }.bind(this), false)

      if (this.file) {
        let minSizeK = 10
        let maxSizeM = 15
        let minSizeBytes = minSizeK * 1024
        let maxSizeBytes = maxSizeM * 1024 * 1024

        if (this.file.type !== 'image/jpeg') {
          this.$emit('input-error', 'Tillåten bildformat är .jpg')
        } else if (this.file.size < minSizeBytes) {
          this.$emit('input-error', 'Bildfilen behöver vara minst ' + minSizeK + ' kB')
        } else if (this.file.size > maxSizeBytes) {
          this.$emit('input-error', 'Bildfilen får vara max ' + maxSizeM + ' MB')
        } else {
          reader.readAsDataURL(this.file)
          this.$emit('input', this.file)
          this.$emit('preview-show', this.show)
        }
      }
    }
  },
  watch: {
    resetPreview () {
      if (this.resetPreview) {
        this.file = null
        this.image = null
        this.show = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/modules/_variables.scss';

.image-preview {
  background-color: map-get($colors, gray-whiter);
  color: map-get($colors, gray-medium);
  width: 110px;
  height: 83px;
  padding: 4px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-preview .fas {
  font-size: 14px;
  position: absolute;
}

.image-preview-disabled {
  opacity: 0.4;
}

.image-preview-disabled .image-preview-label {
  cursor: auto;
}

.image-preview-label {
  border: 1px solid map-get($colors, gray-light);
  border-radius: 3px;
  box-shadow: 0 0 0 3px map-get($colors, gray-white) inset;
  cursor: pointer;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 100;
}

.image-preview-input {
  display: none;
}

.item-preview-image {
  max-width: 100%;
  max-height: 100%;
  z-index: 10;
}

.item-preview-delete {
  background-color: map-get($colors, red-light);
  border: 1px solid map-get($colors, red-base);
  border-radius: 3px;
  color: #fff;
  cursor: pointer;
  width: 20px;
  height: 20px;
  position: absolute;
  top: -4px;
  right: -4px;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-fade-enter-active,
.image-fade-leave-active {
  transition: opacity 0.3s cubic-bezier(.68,-0.55,.27,1.55);
}

.image-fade-enter,
.image-fade-leave-to {
  opacity: 0;
}
</style>
